import React, { memo } from 'react'
import { MenuItem, MenuList } from '@mui/material'
import {
  faCartArrowDown,
  faChevronDown,
  faShareFromSquare
} from '@fortawesome/pro-duotone-svg-icons'
import { usePopover } from 'minimal-shared/hooks'

import Button from '../shared/button/Button'
import { NFT_ACTIONS_STEPS } from '../../constants/nft'
import { CustomPopover } from '../shared/custom-popover'
import FaIcon from 'src/components/shared/faIcon/FaIcon'

const NftMoreActions = ({
  t,
  onNftActionSelect,
  canSell,
  canTransfer,
  loading
}) => {
  const menuActions = usePopover()
  const renderMenuActions = () => (
    <CustomPopover
      open={menuActions.open}
      anchorEl={menuActions.anchorEl}
      onClose={menuActions.onClose}
      slotProps={{ arrow: { placement: 'top-right' } }}
    >
      <MenuList>
        {canSell && (
          <MenuItem
            onClick={() => {
              menuActions.onClose()
              onNftActionSelect(NFT_ACTIONS_STEPS.SELL)
            }}
          >
            <FaIcon icon={faCartArrowDown} />
            {t('nft.sell')}
          </MenuItem>
        )}
        {canTransfer && (
          <MenuItem
            onClick={() => {
              menuActions.onClose()
              onNftActionSelect(NFT_ACTIONS_STEPS.TRANSFER)
            }}
          >
            <FaIcon icon={faShareFromSquare} />
            {t('nft.transfer')}
          </MenuItem>
        )}
      </MenuList>
    </CustomPopover>
  )
  return (
    <>
      <Button
        color='inherit'
        variant='contained'
        endIcon={<FaIcon icon={faChevronDown} />}
        onClick={menuActions.onOpen}
        label={t('nft.more-actions')}
        loading={loading}
      />
      {renderMenuActions()}
    </>
  )
}

export default memo(NftMoreActions)
